<div class="contact-merchant" [style.--color]="brandColor">
  <div class="need-help">
    <div class="shop-icon" [style.--color]="brandColor + '0A'">
      <img [src]="'assets/shop.svg'" alt="contact-us" />
    </div>
    <div class="need-help-text">
      <div class="title">Need help?</div>
      <div class="action">Contact {{ merchantName ? merchantName : 'us' }}</div>
    </div>
  </div>
  <div class="contact-methods">
    <a
      *ngIf="merchantEmail"
      [href]="'mailto:' + merchantEmail"
      trackable="{{ contained ? 'Settings/' : '' }}Tracking page/{{ orderStatus }}/Contact merchant email">
      <common-email-icon [color]="textColor"></common-email-icon>
    </a>
    <a
      *ngIf="merchantPhone"
      [href]="'tel:' + merchantPhone"
      trackable="{{ contained ? 'Settings/' : '' }}Tracking page/{{ orderStatus }}/Contact merchant phone">
      <common-phone-icon [color]="textColor"></common-phone-icon>
    </a>
  </div>
</div>
